export default __webpack_public_path__ + "static/media/penellagen_logo_white.5ae1ec53.svg";